<mat-card>
  <mat-card-title>Ha cerrado sesión correctamente</mat-card-title>
  <mat-card-actions align="end">
    <a routerLink="/ingresar" mat-button>Ingresar</a>
  </mat-card-actions>
</mat-card>
